import { render, staticRenderFns } from "./editsiteinfo.vue?vue&type=template&id=2246a9aa"
import script from "./editsiteinfo.vue?vue&type=script&lang=js"
export * from "./editsiteinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports